import { render, staticRenderFns } from "./SlidePage.vue?vue&type=template&id=13278da0&scoped=true&"
import script from "./SlidePage.vue?vue&type=script&lang=js&"
export * from "./SlidePage.vue?vue&type=script&lang=js&"
import style0 from "./SlidePage.vue?vue&type=style&index=0&id=13278da0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13278da0",
  null
  
)

export default component.exports